import $ from 'cash-dom';
import FieldsList from './FieldsList';
import BaseField from './fields/BaseField';
import DropdownField from './fields/DropdownField';
import RangeInputField from './fields/RangeInputField';
import CheckboxField from './fields/CheckboxField';
import SelectboxField from './fields/SelectboxField';
import RadioGroupField from './fields/RadioGroupField';
import InputField from './fields/InputField';
import TabSingleField from './fields/TabSingleField';

class FieldsBuilder {
	/**
	 * Builds filter fields. Each field must have `data-type` attribute and `filter-field` class.
	 * @param {Selector|Cache} $filtersHolder Selector of Cache instance.
	 * @return {FieldsList}
	 */
	static build($filtersHolder) {
		$filtersHolder = $($filtersHolder);
		const fieldsList = new FieldsList();

		const $filterFields = $filtersHolder.find('.filter-field');

		$filterFields.each((o, field) => {
			const $field = $(field);

			const filterField = FieldsBuilder._buildField($field);

			if (filterField) {
				fieldsList.add(filterField);
			}
		});

		return fieldsList;
	}

	static _buildField($field) {
		const type = $field.data('type');

		switch (type) {
			case BaseField.TYPE_DROPDOWN:
				return new DropdownField($field);
			case BaseField.TYPE_INPUT:
				return new InputField($field);
			case BaseField.TYPE_RANGE_INPUT:
				return new RangeInputField($field);
			case BaseField.TYPE_CHECKBOX:
				return new CheckboxField($field);
			case BaseField.TYPE_SELECTBOX:
				return new SelectboxField($field);
			case BaseField.TYPE_RADIO_GROUP:
				return new RadioGroupField($field);
			case BaseField.TYPE_TAB:
				return new TabSingleField($field);
			default:
				console.warn('Unsupported field type "' + type + '"');
				return null;
		}
	}
}

export default FieldsBuilder;
